<template>
<div v-if="!eventsLoading">
  <h2 style="margin-top: 0">{{events.length}} {{ events.length == 1 ? 'ähnliches Bewegungsangebot' : 'ähnliche Bewegungsangebote'}} gefunden</h2>
  <events-list :events="events" :loading="eventsLoading" context="similar" />
</div>
</template>
<script>

import EventsList from "../components/_events_list.vue"
import axios from 'axios';

export default {
  name: 'Similar',
	components: {
    EventsList,
	},
  data(){
    return {
      eventId: document.querySelector('.event-details').dataset.eventId,
      events: [],
      eventsLoading: true
    }
  },
  created(){
    axios.get(`/events/similar/${this.eventId}`)
    .then(r => {
      this.events = r.data.events
      this.eventsLoading = false
    })
  },



}
</script>
